export * from '@primeuix/themes/material/terminal';
export { default } from '@primeuix/themes/material/terminal';
